import { useId } from 'react'
import type { MeasurementSystem } from '../lib/measurementSystem'

export function MeasurementSystemSelect({ value, onChange, disabled = false }: {
  value: MeasurementSystem; onChange: (system: MeasurementSystem) => void; disabled?: boolean
}) {
  const id = useId()
  return <div className="flex min-w-0 flex-wrap items-center gap-2 text-sm">
    <label htmlFor={id}>Système de mesure</label>
    <select id={id} value={value} disabled={disabled} onChange={e => onChange(e.target.value as MeasurementSystem)} className="rounded-lg border border-slate-300 bg-white px-3 py-2 text-slate-900 dark:bg-slate-800 dark:text-white">
      <option value="metric">Métrique</option>
      <option value="imperial">Impérial</option>
    </select>
  </div>
}
